import { PricingService } from "../../lookup/pricing/PricingService";

import { ProfilePromiseActionService } from "../../profile/impl/ProfilePromiseActionService";
import { ProfileSettingKeys } from "../core/ProfileSettingKeys";

export class LadderSpotTrackingHelper {
  protected MAX_ABOVE_MARKET: number = 10001;
  protected MIN_BELOW_MARKET: number = -10001;

  protected pricingService: PricingService;
  protected myDealtMode: boolean;
  protected pinTriggeredEnabled: boolean = true;

  constructor(pricingService: PricingService, private profileService: ProfilePromiseActionService) {
    this.pricingService = pricingService;
    this.myDealtMode = false;

    this.profileService
      .getProfileConfig(ProfileSettingKeys.userProfileSettingsOrderBlotterPreferences)
      .then((profileValue) => {
        this.mapUserSettings(profileValue);
      });

    this.profileService
      .getProfileConfigUpdates(ProfileSettingKeys.userProfileSettingsOrderBlotterPreferences)
      .subscribe((profileValue) => {
        this.mapUserSettings(profileValue);
      });
  }

  protected mapUserSettings(profileValue: any) {
    if (profileValue) {
      let savedSettings = JSON.parse(profileValue);
      if (savedSettings != undefined && savedSettings != null) {
        this.pinTriggeredEnabled =
          savedSettings.hasOwnProperty("pinTriggeredOrdersModel") &&
          savedSettings.pinTriggeredOrdersModel !== null &&
          savedSettings.pinTriggeredOrdersModel == "y"
            ? true
            : false;
      }
    }
  }

  // getValue(order: any, columnProperty:string): string {
  //   let value = super.getValue(order, columnProperty);
  //   return `<span title="">${value}</span>`;
  // }

  getInvertValue(order: any, columnProperty: string): string {
    if (this.pricingService) {
      return this.pricingService.getInvertSpotTracking(order);
    }
    return String(order[columnProperty]);
  }

  retrieveInvertData(order: any, columnProperty: string): string {
    let value = this.getInvertValue(order, columnProperty);

    if (this.pricingService) {
      if (this.pricingService.isStrikethroughSpotTracking(order))
        value = `<span class="no-rate-strike">&nbsp;&nbsp;&nbsp;${value}&nbsp;&nbsp;&nbsp;</span>`;

      if (!order.isInvertedOrderFg) {
        return `<span style="float: left;"><sup>1</sup>/<sub>n</sub></span>${value}`;
      }
    }

    return value;
  }

  getValue(order: any, columnProperty: string): string {
    if (this.pricingService) {
      return this.pricingService.getBlotterSpotTracking(order);
    }
    return String(order[columnProperty]);
  }

  retrieveSortData(order: any, value: string | number): number {
    let sorVal: number = 0;
    if (value != "-" && value != "" && !Number.isNaN(value)) {
      sorVal = Number(value);
    }
    let isAboveMarket: boolean = this.pricingService.isLadderAboveMarket(order);
    let isAlgo: boolean = this.pricingService.isAlgo(order);
    let isAlgoNoTrackingRate: boolean =
      this.pricingService.isMarketOrder(order) || (isAlgo ? order.requestRt == null : false);
    sorVal =
      Number(sorVal) +
      this.pricingService.calculatePinAdjustment(
        order,
        isAboveMarket,
        isAlgoNoTrackingRate,
        this.pinTriggeredEnabled,
      );

    return sorVal;
  }

  retrieveInvertSortData(order: any, value: string | number): number {
    let sorVal: number = 0;
    if (value != "-" && value != "" && !Number.isNaN(value)) {
      sorVal = Number(value);
    }
    let isAboveMarket: boolean = !this.pricingService.isLadderAboveMarket(order);
    let isAlgo: boolean = this.pricingService.isAlgo(order);
    let isAlgoNoTrackingRate: boolean =
      this.pricingService.isMarketOrder(order) || (isAlgo ? order.requestRt == null : false);
    sorVal =
      Number(sorVal) +
      this.pricingService.calculatePinAdjustment(
        order,
        isAboveMarket,
        isAlgoNoTrackingRate,
        this.pinTriggeredEnabled,
      );

    return sorVal;
  }
}
